import React from 'react';
import { AutocompleteArrayInput, ReferenceArrayInput } from 'react-admin';
import { filterToQuery } from '../../../utils';
import { getChainId } from '../../../lib';

const FormCity: React.FC<{ formData?: any }> = () => (
  <>
    <ReferenceArrayInput
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
      source="cityIds"
      reference="cities"
      filter={{ chainId: getChainId() }}
    >
      <AutocompleteArrayInput
        label="Cidades"
        optionText="name"
        filterToQuery={filterToQuery}
        sx={{ width: 300 }}
      />
    </ReferenceArrayInput>
  </>
);

export default FormCity;
